

























import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Mixin from '../mixin';

@Component
export default class Send extends Mixin {
  @Prop() private groupid!: string;
  private data: FormData = new FormData();
  private title: string = '';
  private body: string = '';
  private notImg: boolean = false;

  private async send(event: any) {
    event.preventDefault();
    if (event.target.disabled) {
      return;
    }
    try {
      if (this.title.length < 1) {
        this.msg('タイトルを入力してください');
        (this.$el.querySelector('#title') as HTMLInputElement).focus();
        return;
      }
      if (this.body.length < 1) {
        this.msg('本文を入力してください');
        (this.$el.querySelector('#body') as HTMLInputElement).focus();
        return;
      }
      event.target.disabled = true;
      const data = new FormData(this.$el.querySelector('form')!);
      const xhr = new XMLHttpRequest();
      xhr.open('POST', this.$apiPath + '/pub/message/new');
      xhr.setRequestHeader('Authorization', (await Auth.currentSession() as any).idToken.jwtToken);
      xhr.onload = (ev) => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this.msg('メッセージを送信しました');
            this.$router.go(-1);
          } else {
            this.msg(xhr);
          }
        }
      };
      xhr.send(data);
    } catch (ex) {
      this.msg(ex);
    } finally {
      event.target.disabled = false;
    }
  }

  private checkSize(event: any) {
    const sendButton = this.$el.querySelector('#send')! as any;
    sendButton.disabled = false;
    let size = 0;
    Array.from(event.target.files).forEach((f: any) => {
      if (f.type && !f.type.match(/^image/)) {
        this.notImg = true;
      }
      size += f.size;
    });
    if (size > 1024 * 1024 * 9) {
      this.msg('ファイルの合計サイズが10MBを超えているため、送信できません');
      sendButton.disabled = true;
    }
  }

}
